import type { Contact } from '../types';

export const normalizePhone = (value?: string) => String(value || '').replace(/[^\d+]/g, '').replace(/^00/, '+');
export const normalizeEmail = (value?: string) => String(value || '').trim().toLowerCase();

export const normalizeContactInput = (input: Partial<Contact>) => {
  const name = String(input.name || '').trim().replace(/\s+/g, ' ');
  const phone = String(input.phone || '').trim();
  const email = String(input.email || '').trim();
  return {
    ...input,
    name,
    phone,
    email,
    normalizedPhone: normalizePhone(phone),
    normalizedEmail: normalizeEmail(email),
    source: input.source || 'manual',
    active: input.active ?? true
  } satisfies Partial<Contact>;
};

export const contactDuplicateKey = (contact: Partial<Contact>) =>
  contact.normalizedPhone || contact.normalizedEmail || '';

export const contactDuplicateKeys = (contact: Partial<Contact>) =>
  [contact.normalizedPhone, contact.normalizedEmail].filter(Boolean) as string[];
